import { useId } from "react";
import PropTypes from "prop-types";
import { HoverCard } from "@hireart/component-library";
import { Mid, Value } from "./styles";

export const MidWithHover = ({ content, theme, width, category }) => {
  const popupId = useId();
  return (
    <HoverCard
      id={popupId}
      content={`${content} hours ${category}`}
      trigger={
        <Mid width={width} style={theme}>
          <Value>{content}</Value>
        </Mid>
      }
    />
  );
};

MidWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
